import React from 'react';
import styles from './TableContent.module.scss';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import moment from 'moment';

const TableContent = ({
    renderData = [],
    renderModal
}) => {

    const tableOperate = (text, item) => {
        return (
            <div className={styles.action}>
                <div
                    className={styles.item}
                    onClick={() => renderModal({ state: true, id: text, libType: item.libType, libText: item.libText, type: 'detail', title: '详情' })}
                >详情</div>
                <div
                    className={styles.item}
                    onClick={() => renderModal({ state: true, id: text, libType: item.libType, libText: item.libText, type: 'edit', title: '编辑' })}
                >编辑</div>
            </div>
        );
    };

    const columns = [
        {
            title: '类型',
            dataIndex: 'libType',
            key: 'libType',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '使用位置',
            dataIndex: 'useScene',
            key: 'useScene',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作人',
            dataIndex: 'modifyUserName',
            key: 'modifyUserName',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '更新时间',
            dataIndex: 'gmtModify',
            key: 'gmtModify',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: text => tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss'))
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '12%',
            onCell: tooltipStyle,
            render: tableOperate
        },
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={r => r.id}
            columns={columns}
            dataSource={renderData}
            pagination={false}
            scroll={{ y: true }}
        />
    </div>;
};

TableContent.propTypes = {
    renderData: PropTypes.array.isRequired, // 表格数据源
    renderModal: PropTypes.func
};

export default TableContent;

